import React from 'react';
import PageHeader from '../PageHeader';

const RulesHeaderRight: React.FC<JSX.IntrinsicElements['div']> = ({ children, ...props }) => {
    return <PageHeader.Right {...props}>{children}</PageHeader.Right>;
};

export default RulesHeaderRight;
